'use strict';

const ajax = require('../modules/ajax');
const removeParamFromURL = require('../modules/util/removeParamFromURL');
const appendParamsToUrl = require('../modules/util/appendParamsToUrl');
const search = require('./search');
const grid = require('../grid');
const productTile = require('../product-tile');
const isInViewport = require('../modules/helpers/isInViewport');
const isSmallView = require('../modules/helpers/isSmallView');
const scrollHelper = require('../modules/helpers/scroll');
const $filterOverlay = $('.js-refinements-bar');
const $filterPage = $('.js-filter-page');
const $filterOptions = $('.js-filter-options');
const $filterBlockTitle = $('.js-filter-block-title');

const ALL = 'all';

function clearAllFilters(){
    const data = {
        cat: ALL
    };

    getFilteredProducts(data);

    $('.js-filter__block input[type=checkbox]').prop('checked', false);
}

function getFilteredProducts(filterData){
    const path = window.location.pathname;

    if (!('format' in filterData)){
        filterData.format = 'page-element-with-banner';
    }

    $.ajax({
        dataType: 'html',
        url: path,
        data: filterData,
        xhrFields: {
            withCredentials: true
        }
    }).done(function (response) {
        updateProductGrid(response);
        updateUrls();

        updateFilterTags();
        updateMobileFilterText();
    });
}

function updateProductGrid(html) {
    if (!html) {
        return;
    }

    $('.js-grid-wrap .js-grid-item').remove();
    $('.js-grid-wrap').append(html);
    grid.updateLoadMoreUrl();

    //reinit the grid
    $('.js-grid-wrap').imagesLoaded(function() {
        grid.init();
    });
}

function updateUrls() {
    const newUrlElement = $('.js-new-current-url');

    if (newUrlElement.length > 0) {
        const newUrl = newUrlElement.last().val();
        window.history.pushState({'url': newUrl}, '', newUrl);
        newUrlElement.remove();
    }
}

function updateFilters(){
    const url = Urls.getOutletFilterAvailability;

    $.when(getFilterSelection()).done(function(data) {
        ajax.getJson({
            url: url,
            data: data,
            callback: function(response){
                // enable/disable input fields
                $.each(response, function (key, value) {
                    if (typeof value === 'object') {
                        $.each(value, function(key, value) {
                            $('input[data-inputid="' + key + '"]').prop('disabled', value !== true);
                        });
                    } else {
                        $('input[data-inputid="' + key + '"]').prop('disabled', value !== true);
                    }
                });

                // update filter count
                $('.js-filters-count').html(response.count);
            }
        });
    });
}

function getFilterSelection(){
    const categoriesArray = $('input[name="category-categoryflow"]:enabled:checked').map(function () {
        return $(this).val();
    }).get();

    const subCategoriesArray = $('input[name="subcategory"]:enabled:checked').map(function () {
        return $(this).val();
    }).get();

    const categories = categoriesArray.length > 0 ? categoriesArray.join() : ALL;
    const subCategories = subCategoriesArray.length > 0 ? subCategoriesArray.join() : ALL;

    const data = {
        cat: categories,
        subcat: subCategories
    };

    const sortingRule = $('.js-outlet-sort-by-select').data('sorting-rule');
    if (sortingRule) {
        data.srule = sortingRule;
    }

    return data;
}

function applyFilters(){
    $.when(getFilterSelection()).done(function(data) {
        getFilteredProducts(data);
    });
}

function updateFilterTags(){
    const newFilterTagContainer = $('.js-new-active-refinements-list');
    const oldFilterTagContainers = $('.js-active-refinements-list');

    if (newFilterTagContainer.length > 0) {
        const newFilters = $('.js-new-active-refinements-list .js-active-refinements');
        oldFilterTagContainers.empty();
        oldFilterTagContainers.append(newFilters);
        newFilterTagContainer.remove();
    }
}

function updateMobileFilterText(){
    const newFilterTextContainer = $('.js-new-mobile-selected-filters');
    const oldFilterTextContainers = $('.js-filter-selected-item');

    const newFilterText = newFilterTextContainer.text();
    oldFilterTextContainers.text(newFilterText);

    newFilterTextContainer.remove();
}

function initEvents() {
    const $body = $('body');

    //open filter overlay
    $body.off('click', '.js-trigger-mobile-filters');
    $body.on('click', '.js-trigger-mobile-filters', function () {
        $filterOverlay.fadeIn('fast', function () {
            const $this = $(this);
            redesignAdjustments();
            $this.addClass('refinements-visible').removeAttr('aria-hidden');
            $this.find('.js-filter-block-title').focus();

            if (isSmallView()) {
                $('.js-search-results-bar').css('height', '');
            }
        });

        // lock body scroll
        scrollHelper.disableScroll();
    });

    //close filter overlay
    $body.off('click', '.js-background-overlay, .js-filters-close, .js-filter-x-close, .js-filter-option-close');
    $body.on('click', '.js-background-overlay, .js-filters-close, .js-filter-x-close, .js-filter-option-close', function(){
        if (isSmallView()) {
            if ($filterOptions.hasClass('visible')) {
                $filterOptions.addClass('moved-left');
            }

            $filterOverlay.removeClass('refinements-visible').removeClass('moved-left').attr('aria-hidden', 'true');
            $('.js-search-results-bar').find('.js-trigger-mobile-filters').focus();

            setTimeout(function () {
                $filterOptions.hide().removeClass('visible').removeClass('moved-left').attr('aria-hidden', 'true');
                $filterBlockTitle.removeClass('open');
                $filterOverlay.hide();
            }, 800);
        } else {
            $filterOverlay.removeClass('refinements-visible').attr('aria-hidden', 'true');
            $filterBlockTitle.removeClass('open');
            $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
            $('.js-search-filter-box').find('.js-trigger-mobile-filters').focus();
            setTimeout(function () {
                $filterOverlay.hide();
            }, 600);
        }

        // unlock body scroll
        scrollHelper.enableScroll();
    });

    $('.js-filters-close').on('keydown', function (e) {
        if (e.which == 9 && !e.shiftKey) {
            e.preventDefault();
            $('.js-filter-x-close').focus();
        }
    });

    $('.js-filter-x-close').on('keydown', function (e) {
        if (e.shiftKey && e.which == 9) {
            e.preventDefault();
            $('.js-filters-close').focus();
        }
    });

    if (isSmallView()) {
        $('.js-filter-block-title').removeAttr('aria-label aria-expanded');
    }

    //toggle filter items on mobile
    $body.off('click', '.js-filter-block-title');
    $body.on('click', '.js-filter-block-title', function() {
        const ariaLabelText = $(this).text();
        const ariaLabelStateOpen = $('.js-filter-label-open').text();
        const ariaLabelStateClosed = $('.js-filter-label-closed').text();

        if (!$(this).hasClass('open')) {
            $(this).addClass('open');
            if (isSmallView()) {
                $(this).next('.js-filter-options').show('fast', function () {
                    $filterOverlay.addClass('moved-left');
                    $(this).addClass('visible').addClass('visible').removeAttr('aria-hidden');
                });
                $(this).next('.js-filter-options').find('.js-filter-option-back').focus();
            } else {
                $(this).next('.js-filter-options').stop().slideDown().removeAttr('aria-hidden');
                $(this).attr({
                    'aria-label': ariaLabelText + ',' + ariaLabelStateOpen,
                    'aria-expanded' : 'true'
                });
            }
        } else {
            $(this).removeClass('open');
            if (isSmallView()) {
                $(this).next('.js-filter-options').removeClass('visible').attr('aria-hidden', 'true');
            } else {
                $(this).next('.js-filter-options').stop().slideUp().attr('aria-hidden', 'true');
                $(this).attr({
                    'aria-label' : ariaLabelText + ',' + ariaLabelStateClosed,
                    'aria-expanded' : 'false'
                });
            }
        }
    });

    if (isSmallView()) {
        $('.js-clear-filters').on('keydown', function (e) {
            if ($filterOptions.hasClass('visible')) {
                if (e.which == 9) {
                    e.preventDefault();

                    $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
                    $filterBlockTitle.removeClass('open');

                    setTimeout(function () {
                        $filterOptions.hide();
                    }, 600);
                }
            }
        });
    }

    //close categories on mobile
    $body.off('click', '.js-filter-option-back');
    $body.on('click', '.js-filter-option-back', function () {
        if (isSmallView()) {
            $filterOverlay.removeClass('moved-left');
        }
        $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
        $filterBlockTitle.removeClass('open');

        setTimeout(function () {
            $filterOptions.hide();
        }, 600);
    });

    $body.off('change', '.js-outlet-sort-by-select');
    $body.on('change', '.js-outlet-sort-by-select', function () {
        const sortingRule = $(this).val();

        let url = removeParamFromURL(location.href, 'format');
        url = removeParamFromURL(url, 'srule');
        url = appendParamsToUrl(url, {
            'format': 'page-element-with-banner',
            'srule': sortingRule
        });

        $.ajax({
            url: url,
            success: function (data) {
                updateProductGrid(data);
                updateUrls();
            }
        });
    });

    $body.off('click', '.js-remove-filter-button');
    $body.on('click', '.js-remove-filter-button', function() {
        const attributeValue = $(this).data('refinement-value');
        $('.js-filter-option[value="' + attributeValue + '"]').prop('checked', false);
        applyFilters();
    });

    // OOP: clear filters
    $body.off('click', '.js-clear-filters');
    $body.on('click', '.js-clear-filters', function() {
        clearAllFilters();

        redesignAdjustments();
    });

    // OOP: listen to filter changes and update filters
    $body.off('change', '.js-filter-option');
    $body.on('change', '.js-filter-option', function() {
        // update filter panel
        updateFilters();

        // apply filters and fetch products
        applyFilters();
    });

    $(document).on('keyup', function(e) {
        if (e.which == 27) {
            // on escape close the overlay
            if ($filterOverlay.hasClass('refinements-visible')) {
                if (isSmallView()) {
                    $filterPage.animate({
                        left: '0'
                    }, 600, 'easeInOutCubic');
                    if ($filterOptions.hasClass('visible')) {
                        $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
                        $('.filter-user-actions').css('left', '100%');
                    } else {
                        $filterOverlay.addClass('moved-right').attr('aria-hidden', 'true');
                    }
                    $('.js-search-results-bar').find('.js-trigger-mobile-filters').focus();

                    setTimeout(function () {
                        $filterOverlay.removeClass('refinements-visible').removeClass('moved-right').removeClass('moved-left');
                        $filterBlockTitle.removeClass('open');
                        $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
                    }, 800);
                } else {
                    $filterOverlay.removeClass('refinements-visible').attr('aria-hidden', 'true');
                    $filterBlockTitle.removeClass('open');
                    $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
                    $('.js-search-filter-box').find('.js-trigger-mobile-filters').focus();
                }

                // unlock body scroll
                scrollHelper.enableScroll();
            }
       }
   });

    accessibilityAdjustments();
    redesignAdjustments();
    stickyNavBar();
    searchGWPAssetPosition();

    $(window).on('resize', function () {
        accessibilityAdjustments();
        redesignAdjustments();
        searchGWPAssetPosition();
    });

    $(window).scroll(function () {
        stickyNavBar();
    });
}

function accessibilityAdjustments() {
    if (isSmallView()) {
        $('.js-filter-category-title').attr('aria-hidden', 'true');
    } else {
        $('.js-filter-category-title').removeAttr('aria-hidden');
    }
}

function redesignAdjustments() {
    const $filterInner = $('.js-filter-inner');

    if ($filterInner.length) {
        const filterHeaderHeight = $('.js-filter-header').outerHeight();

        $filterInner.css('padding-top', filterHeaderHeight);
    }
}

function stickyNavBar() {
    const $filterBar = $('.js-search-results-bar');
    const $darkBox = $('.js-search-filter-box');

    if ($filterBar.length) {
        const barIsInView = isInViewport($filterBar);
        const boxIsInView = isInViewport($darkBox);
        const filterBarPosition = $filterBar.offset().top;

        if (isSmallView()) {
            if ($(window).scrollTop() >= filterBarPosition) {
                $filterBar.addClass('sticky-filters');
            } else {
                $filterBar.removeClass('sticky-filters');
            }
        } else {
            if (barIsInView) {
                $filterBar.removeClass('sticky-filters');
            } else {
                $filterBar.addClass('sticky-filters');
            }

            if (boxIsInView) {
                $filterBar.removeClass('sticky-filters-visible');
            } else {
                $filterBar.addClass('sticky-filters-visible');
            }
        }
    }
}

function searchGWPAssetPosition() {
    if ($('.js-search-grid-asset').length) {
        const searchAsset = '.js-search-grid-asset';
        const desktopAssetHolder = '.js-search-slot-desktop';
        const mobileFirstGridItem = $('.js-search-result-content').find('.js-grid-item').first();
        if (isSmallView()) {
            $(desktopAssetHolder).find(searchAsset).appendTo(mobileFirstGridItem);
        } else {
            $(mobileFirstGridItem).find(searchAsset).appendTo(desktopAssetHolder);
        }
    }
}

exports.init = function init () {
    initEvents();

    // initialize search page events (e.g.: product options click)
    search.initGridOptionsEvents();
    productTile.init();
};
